import { Injectable, signal } from '@angular/core';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../constants/auth.constants';

@Injectable({ providedIn: 'root' })
export class TokenService {
    private accessToken = signal<string | null>(localStorage.getItem(ACCESS_TOKEN_KEY));
    private refreshToken = signal<string | null>(localStorage.getItem(REFRESH_TOKEN_KEY));

    public setTokens(accessToken: string | null, refreshToken: string | null): void {
        this.persist(ACCESS_TOKEN_KEY, accessToken);
        this.persist(REFRESH_TOKEN_KEY, refreshToken);
        this.accessToken.set(accessToken);
        this.refreshToken.set(refreshToken);
    }

    public clear(): void {
        this.setTokens(null, null);
    }

    public getAccessToken(): string | null {
        return this.accessToken();
    }

    public getRefreshToken(): string | null {
        return this.refreshToken();
    }

    private persist(key: string, value: string | null): void {
        if (value === null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    }
}
